module.exports = __webpack_public_path__ + "img/cbam-3-en.887f339b.png";